import { Button, message, Popconfirm, Space } from 'antd';
import { rejectClass } from '../ApiServices/classAdminApi';

const getClassPublishedColumns = (navigate, fetchClasses, currentPage, handleEditClass) => [
  {
    title: "Class Title",
    dataIndex: "title",
    key: "title",
    width: 200,
    ellipsis: true
  },
  {
    title: "Class Level",
    dataIndex: "education_class",
    key: "education_class",
    width: 150
  },
  {
    title: "Instructor",
    dataIndex: "instructor",
    key: "instructor",
    width: 150
  },
  {
    title: "Price",
    dataIndex: "cost",
    key: "cost",
    width: 100,
  },
{
  title: "Duration",
  dataIndex: "duration",
  key: "duration",
  width: 120,
  render: (durationInSeconds) => {
    // Convert seconds to hours and minutes
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    
    // Format the output
    let formattedDuration = '';
    if (hours > 0) {
      formattedDuration += `${hours}h `;
    }
    formattedDuration += `${minutes}m`;
    
    return <span>{formattedDuration}</span>;
  }
},
  {
    title: "Actions",
    key: "actions",
    align: "center",
    fixed: 'right',
    width: 200,
    render: (_, record) => (
      <Space size="small">
        <Button
          type="primary"
          onClick={(e) => {
            e.stopPropagation();
            handleEditClass(record);
          }}
          style={{
            fontSize: "12px",
            padding: "4px 8px",
          }}
        >
          Edit
        </Button>
        
        <Popconfirm
          title="Are you sure you want to reject this class?"
          onConfirm={(e) => {
            e?.stopPropagation();
            handleRejectClass(record.id, fetchClasses, currentPage);
          }}
          onCancel={(e) => e?.stopPropagation()}
          okText="Yes"
          cancelText="No"
        >
          <Button
            danger
            onClick={(e) => e.stopPropagation()}
            style={{
              fontSize: "12px",
              padding: "4px 8px",
            }}
          >
            Reject
          </Button>
        </Popconfirm>
      </Space>
    ),
  }
];

const handleRejectClass = async (classId, fetchClasses, currentPage) => {
  try {
    const response = await rejectClass(classId);
    if (response.code === 200) {
      message.success("Class rejected successfully!");
      fetchClasses(currentPage);
    } else {
      message.error("Failed to reject class: " + response.message);
    }
  } catch (error) {
    message.error("Error rejecting class: " + error.message);
  }
};

export default getClassPublishedColumns;